import React from 'react';
import { useNavigate } from 'react-router';

import { ButtonGroup, StandardButton } from '@eika/button';
import { ErrorCard, InfoCard } from '@eika/card';
import { Loader } from '@eika/loader';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useClick2PayProfileMutationResult } from '@/react-query/hooks/query/use-click2pay';

import { Click2PayProcessStatus } from '@generated-types';
import useText from '@hooks/use-text';

const Click2PaySummary = () => {
    const text = useText();

    const navigate = useNavigate();
    const mutationResult = useClick2PayProfileMutationResult();

    if (mutationResult.isPending) {
        return <Loader />;
    }

    if (mutationResult.isError || mutationResult.data?.status === Click2PayProcessStatus.FAILED) {
        return (
            <ErrorCard
                title={text.messageErrorUps}
                icon={RichIconTypes.NETTVERKSBRUDD_HARE}
                description={text.click2PayGenericError}
                exception={mutationResult.error}
            >
                <ButtonGroup
                    primaryAction={
                        <StandardButton onClick={() => navigate('/')}>{text.click2PayGoToHome}</StandardButton>
                    }
                />
            </ErrorCard>
        );
    }

    return (
        <InfoCard title="Click2PayLinkCard">
            <RichIcon type={RichIconTypes.FERDIG} />
            <h3>Kort legges til i Click to Pay</h3>
            <p>Du mottar en e-post med bekreftelse fra oss når det er klart til bruk</p>
            <ButtonGroup
                primaryAction={<StandardButton onClick={() => navigate('/')}>{text.click2PayGoToHome}</StandardButton>}
            />
        </InfoCard>
    );
};
export default Click2PaySummary;
